import { render, staticRenderFns } from "./formLogin.vue?vue&type=template&id=0f48415d&scoped=true"
import script from "./formLogin.vue?vue&type=script&lang=js"
export * from "./formLogin.vue?vue&type=script&lang=js"
import style0 from "./formLogin.vue?vue&type=style&index=0&id=0f48415d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48415d",
  null
  
)

export default component.exports